import type { Course, Enum_Like_Type, KnowledgeBase } from '@edwin-group/people-graphql';

import BookmarkButton from '../Bookmark/BookmarkButton';
import LikeButton from '../LikeButton';
import { GENERATED } from '@edwin-group/people-graphql';

type TitleWithActionsProps = {
  title: string;
  entity: KnowledgeBase | Course;
  entityId: string;
  moduleId?: string;
  lessonId?: string;
  like?: boolean;
  favorite?: boolean;
  type?: Enum_Like_Type;
  category?: GENERATED.Enum_Bookmark_Category;
  textSize?: string;
  knowledgeBaseTypeId?: string;
};

export default function TitleWithActions({
  title,
  like = true,
  favorite = true,
  entity,
  entityId,
  lessonId,
  moduleId,
  category,
  textSize = 'text-sh-30-38',
  type,
  knowledgeBaseTypeId,
}: TitleWithActionsProps) {
  return (
    <div className="flex items-start justify-between gap-2">
      <h1 className={`font-haffer ${textSize} font-bold`}>{title}</h1>
      <div className="flex items-end gap-sh-15">
        <div className="flex items-center justify-center">
          {title && like && type && (
            <LikeButton entityId={entityId} type={type} lessonId={lessonId} moduleId={moduleId} />
          )}
        </div>
        <div className="flex items-center justify-center">
          {title && favorite && category && (
            <BookmarkButton
              relationId={entityId || ''}
              metadata={entity!}
              category={category}
              typeId={knowledgeBaseTypeId}
            />
          )}
        </div>
      </div>
    </div>
  );
}
